import React, { useState, useEffect } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate, useParams } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import axios from "axios";
import { setTime } from "react-datepicker/dist/date_utils";
import {  updateTeri,getDropdowns } from "../api/territory"; 
import { getSpecificSales,updateSales  } from "../api/sales"; 
const EditSales = () => {
  const [formData, setFormData] = useState({
    id: "",
    channel_id: "",
    territory_identifier: "",
    channel_name:"",
    max_unplanned_visits:"",
    min_canton_qty:"",
    persona:'',
    checkin_radius:"",
 
  });
  const [values, setValues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const [salesName,setSalesName]=useState('')

  const handleChange = (e: any) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const paramsObj = {
      
      max_unplanned_visits: formData.max_unplanned_visits,
      min_canton_qty: Number(formData.min_canton_qty),
      checkin_radius: Number(formData.checkin_radius),

      
    };

    try {
      setLoading(true);
      const emptyFields = Object.entries(formData)
        .filter(([_, value]) => value === null || value === "")
        .map(([key]) => key);

      setInvalidFields([]);

      // if (emptyFields.length > 0) {
      //   toast.error("Please fill all required fields.");
      //   return;
      // }
       const response = await updateSales(paramsObj, formData.id);
              if (!response) {
                console.warn("Invalid or empty response:", response);
                toast.error("Invalid or empty response");
                return;
              }
      toast.success("Sales Rule updated successfully!");
      setTimeout(() => {
        navigate(URL_MAPPING.SALES);
      }, 2000);
     
    } catch (error: any) {
      console.error("Error fetching territory data:", error,{
        autoClose: false,
        closeOnClick: true,
        draggable: true,
      });
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the territory",{
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.",{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };


 
  useEffect(() => {
    const fetchData = async () => {
      try {
         const response = await getSpecificSales(id as string);
               if (!response) {
                 console.warn("Invalid or empty  response:", response);
                 toast.error("Invalid or empty  response");
                 return;
               }
        const data = response;
        setSalesName(data.sales_office_name)
      
        setFormData({
          id: data.id,
          persona: data.persona || "",
          channel_id: data.channel_id || "",
          channel_name: data.channel_name || "",
          max_unplanned_visits: data.max_unplanned_visits || "",
          min_canton_qty: data.min_canton_qty || "",
          territory_identifier: data.territory_identifier || "",
          checkin_radius: data.checkin_radius || "",
          
        });
      } catch (error: any) {
        console.error("Error fetching customer data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      }
    };
    fetchData();
  }, []);

  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Edit Sales Rule </h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-2/3 sm:w-full">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label className="block font-semibold mb-1">Sales Office Name</label>
      <input name="id" disabled value={salesName} className={getInputClass("id")} />
    </div>

    <div>
      <label className="block font-semibold mb-1">Max Unplanned Visits</label>
      <input
        type="text"
        name="max_unplanned_visits"
        value={formData.max_unplanned_visits}
        onChange={handleChange}
        className={getInputClass("max_unplanned_visits")}
        placeholder="Max Unplanned Visits"
      />
    </div>

    <div>
      <label className="block font-semibold mb-1">Min Canton Qty</label>
      <input
        type="text"
        name="min_canton_qty"
        value={formData.min_canton_qty}
        onChange={handleChange}
        className={getInputClass("min_canton_qty")}
        placeholder="Min Canton Qty"
      />
    </div>

    <div>
      <label className="block font-semibold mb-1">Checkin Radius</label>
      <input
        type="text"
        name="checkin_radius"
        value={formData.checkin_radius}
        onChange={handleChange}
        className={getInputClass("checkin_radius")}
        placeholder="Checkin radius"
      />
    </div>

    <div>
      <label className="block font-semibold mb-1">Channel ID</label>
      <input
        type="text"
        name="channel_id"
        disabled
        value={formData.channel_id}
        onChange={handleChange}
        className={getInputClass("channel_id")}
        placeholder="Channel ID"
      />
    </div>

    <div>
      <label className="block font-semibold mb-1">Channel Name</label>
      <input
        type="text"
        value={formData.channel_name}
        disabled
        name="channel_name"
        onChange={handleChange}
        className={getInputClass("channel_name")}
      />
    </div>

    <div>
      <label className="block font-semibold mb-1">Persona</label>
      <select
        name="persona"
        value={formData.persona}
        onChange={handleChange}
        disabled
        className={getInputClass("persona")}
      >
        <option value="" disabled hidden>Persona</option>
        <option value="Salesman">Salesman</option>
        <option value="Preseller">Preseller</option>
      </select>
    </div>
  </div>

  <button
    type="submit"
    disabled={loading}
    className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2 mt-5"
  >
    Update Sales Rule {loading && <ButtonLoader />}
  </button>
</form>

    </LayerAdmin>
  );
};

export default EditSales;
